import { createSelector } from '@reduxjs/toolkit';
import { selectDetails } from '../../store/selectors';

export const selectInvestmentServices = createSelector(selectDetails, (details) => details.investmentServices);

export const selectItems = createSelector(selectInvestmentServices, (investmentServices) => investmentServices.items);
